import './App.css';
import TicTacToe from './Components/Component/TicTacToe';

function App() {
  return (
    <div>
      <TicTacToe/>
    </div>
  );
}

export default App;
